import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { AccountCreateEditRequest, IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useAccounts(componentName = "useAccounts") {
  const { get, post } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const accounts = useQuery({
    queryKey: ["accounts"],
    queryFn: () => get<DefaultResponseWithData<IAccount[]>>("/account"),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  const create = useMutation({
    mutationFn: (data: AccountCreateEditRequest) =>
      post<AccountCreateEditRequest, DefaultResponseWithData<IAccount[]>>(
        `/account`,
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries(["contacts"]);
      queryClient.invalidateQueries(["accounts"]);
    }
  });

  return {
    accounts,
    create,
  };
}
